import { pushEvent } from "@wbly/common";
import type { W, DataLayer } from "@wbly/common";

export const trackSortBy = (selectedOption: string) =>
  pushEvent(
    (window as W)?.dataLayer as DataLayer[],
    "",
    "select_sorting_option",
    "sort_by",
    `${selectedOption}`
  );
